import { Component, Input, Inject, AfterViewInit, Output, EventEmitter, DOCUMENT } from '@angular/core';

import { MenuService } from 'app/services/menu.service';

@Component({
  selector: 'prod-menu',
  templateUrl: './prod-menu.component.html',
  standalone: false,
})
export class ProdMenuComponent implements AfterViewInit {
  @Input() products;
  @Input() specialMenuTitle;
  @Input() specialMenuPath;
  @Input() menuId;
  @Input() title;
  @Output() closeMenuEvent = new EventEmitter<boolean>();
  activeFirstElement: HTMLElement;
  constructor(private menuService: MenuService, @Inject(DOCUMENT) private document: Document) {}

  ngAfterViewInit(): void {
    this.activeFirstElement = this.document.querySelector('.-active-first');
  }

  closeMenu() {
    this.closeMenuEvent.emit(true);
  }

  onMouseEnter() {
    if (this.activeFirstElement) {
      this.activeFirstElement.classList.remove('-active-first');
    }
  }

  onMouseLeave() {
    if (this.activeFirstElement) {
      this.activeFirstElement.classList.add('-active-first');
    }
  }
}
